import {
    WorkshiftModel,
    WorkshiftModelAPI,
    WorkshiftTypeModel,
    WorkshiftTypeModelAPI,
} from '../../../../models';

export const getWorkshiftAdapter = (response: WorkshiftModelAPI): WorkshiftModel => {
    const {
        id,
        isActive,
        isAutomaticDiscount,
        isDuplex,
        isExtra,
        isNextTurn,
        name,
        timeAutomaticDiscount,
        workshiftsDayList,
        workshifstAllowances,
    } = response;

    return {
        id,
        isActive,
        isAutomaticDiscount,
        isDuplex,
        isExtra,
        isNextTurn,
        name,
        timeAutomaticDiscount,
        workshiftsDayList,
        workshifstAllowances,
    };
};

export const getAllWorkshiftsTypesAdapter = (
    response: WorkshiftTypeModelAPI[]
): WorkshiftTypeModel[] => {
    return response
        ? response.map((workshift) => {
              return {
                  alias: workshift.alias,
                  id: workshift.id,
                  name: workshift.name,
              };
          })
        : [];
};
